import {
  HttpRequest,
  HttpEvent,
  HttpInterceptorFn,
  HttpHandlerFn,
  HttpStatusCode,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { inject, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { LOCAL_STORAGE_KEYS } from '@constants/storage.constants';

// Services
// import { NotificationsService } from '../services/notifications.service';
// import { EStorageKeys } from '../enums/storage.enums';

export const HttpErrorInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);
  const ngZone = inject(NgZone);
  // const notificationsService = inject(NotificationsService);

  return next(request).pipe(
    catchError(error => {
      switch (error.status) {
        case HttpStatusCode.Unauthorized: {
          localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN);

          // notificationsService.openErrorSnackBar(
          //   'You are unauthorized to do this! Sign In before.',
          // );

          ngZone.run(() => {
            router.navigate(['/auth']);
          });
          break;
        }
      }
      return throwError(error);
    }),
  );
};
